module.exports = __webpack_public_path__ + "img/c.cc8ffff9.png";